import firebase from 'firebase/app';
import db from '../firebaseInit';
import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

const updateBoardDataInFirebase = (boardId, boardDataToStore, callbackFunc = null) => {
  db.collection('boards')
    .where('boardId', '==', boardId)
    .get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        doc.ref
          .update(boardDataToStore)
          .then(() => {})
          .catch(err => {
            this.$snotify.error('Error toggling promoted', '', NOTIFICATION_SETTINGS);
          });
      });
    });
};

export default updateBoardDataInFirebase;
